<template>
  <Layout>
    <div>
      <div class="lg:flex bg-white p-6 shadow">
        <div class="w-full lg:w-1/2">
          <div class="flex items-center">
            <img
              v-if="restaurantInfo"
              :src="restaurantInfo.logo || '/img/default-user.3c1dd009.png'"
              class="w-24 h-24 rounded-full mr-4 border"
              alt="Resto User Avatar"
            />
            <div class="resto-info">
              <div class="pb-4">
                <p class="tracking-tight font-bold text-2xl">{{ restaurantInfo.restaurant_name }}</p>
                <p class="text-grey-dark">{{ restaurantInfo.restaurant_address }}</p>
              </div>
              <p class="text-base text-black font-semibold">Restaurant Hours</p>
              <p v-if="fetchingInfo"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-if="restaurantInfo" class="text-grey-dark">
                {{ restaurantInfo.business_hour.opening_time }} TO {{ restaurantInfo.business_hour.closing_time }}
              </p>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 self-center mt-8 lg:mt-0">
          <div class="flex-wrap lg:flex lg:flex-no-wrap lg:justify-end">
            <div class=" p-4 bg-grey-light lg:mr-2 mb-2">
              <p class="pb-2">Total Earings</p>
              <p v-if="fetchingInfo"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="font-bold">{{ stats.total_earnings }} {{ isBDPhoneNumber() ? 'Tk' : 'NPR' }}</p>
            </div>
            <div class=" p-4 bg-grey-light lg:mr-2 mb-2">
              <p class="pb-2">Total Order</p>
              <p v-if="fetchingInfo"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="font-bold">{{ stats.total_order }}</p>
            </div>
            <div class=" p-4 bg-grey-light lg:mr-2 mb-2">
              <p class="pb-2">Delivered Order</p>
              <p v-if="fetchingInfo"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p else class="font-bold">{{ stats.total_delivered_order }}</p>
            </div>
            <div class=" p-4 bg-grey-light lg:mr-2 mb-2">
              <p class="pb-2">Cancelled Order</p>
              <p v-if="fetchingInfo"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="font-bold">{{ stats.cancelled_order }}</p>
            </div>
            <div class=" p-4 bg-grey-light lg:mr-2 mb-2">
              <p class="pb-2">Avg Proc. Time</p>
              <p v-if="fetchingInfo"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-if="stats.avg_processing_time" class="font-bold">
                {{ (stats.avg_processing_time / 60).toFixed(2) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <pt-button
        :disabled="pullingOrder"
        variant="primary-outline"
        class="float-right sm:mt-2 sm:mb-2"
        @action="pullOrder"
      >
        <i v-if="pullingOrder" class="fa fa-spin fa-spinner mr-2" />
        Pull Order
      </pt-button>

      <div class="lg:flex lg:mt-12 sm:mt-12">
        <div class="w-full lg:w-1/4 border border-solid border-grey-light shadow mb-8 lg:mr-4 bg-white">
          <div class="lg:flex lg:justify-between p-5 bg-grey-lighter border-b border-solid border-grey-light">
            <h3 class="text-xl">popular items</h3>
          </div>
          <ul class="list-reset">
            <li v-for="(item, index) in popularItems" :key="index" class="flex p-2">
              <img
                src="http://storage.pathaofood.live/resto/uploads/assests/item_placeholder.png"
                class="w-16 h-16 rounded"
              />
              <div class="self-center pl-2">
                <p class="text-sm font-bold pb-2">{{ item.item_name }}</p>
                <p>{{ item.order_count }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="w-full lg:w-3/4">
          <div class="border border-solid border-grey-light shadow mb-8">
            <div class="lg:flex lg:justify-between p-4 bg-grey-lighter border-b border-solid border-grey-light">
              <div class="w-full lg:w-1/2 self-center">
                <p class="text-xl pb-4">Earning History</p>
              </div>
              <div class="w-full lg:w-1/2 lg:flex">
                <div class="segment w-full lg:w-1/2 lg:mr-2">
                  <pt-select
                    v-model="selecteSegment"
                    :options="segmentOptions"
                    label-key="name"
                    track-by="name"
                    @select="getBarChartData()"
                  />
                </div>
                <div class="datepicker w-full lg:w-1/2">
                  <pt-datepicker v-model="dateRangeForBarChart" :range="true" label="" />
                </div>
              </div>
            </div>
            <bar-chart
              v-if="barChartLoaded"
              :chart-data="barChartCollection"
              :options="barChartOptions"
              class="p-4 bg-white"
            />
          </div>
          <div class="lg:flex">
            <div class="w-full lg:w-1/3">
              <div class="border border-solid border-grey-light shadow mb-8">
                <div class="lg:flex lg:justify-between p-5 bg-grey-lighter border-b border-solid border-grey-light">
                  <div class="text-xl">Order Ratio</div>
                  <div>Lifetime</div>
                </div>
                <pie-chart
                  v-if="pieChartLoaded"
                  :chart-data="pieChartCollection"
                  :options="pieChartOptions"
                  class="bg-white"
                />
              </div>
            </div>
            <div class="w-full lg:w-2/3">
              <div class="border border-solid border-grey-light shadow mb-8 lg:ml-4">
                <div class="lg:flex lg:justify-between p-5 bg-grey-lighter border-b border-solid border-grey-light">
                  <div class="w-full lg:w-1/2 self-center">
                    <p class="text-xl pb-4">Average Processing Time</p>
                  </div>
                  <div class="w-full lg:w-1/2 lg:flex">
                    <div class="segment w-full lg:w-1/2 lg:mr-2">
                      <pt-select
                        v-model="selecteSegment"
                        :options="segmentOptions"
                        label-key="name"
                        track-by="name"
                        @select="getLineChartData()"
                      />
                    </div>
                    <div class="datepicker w-full lg:w-1/2">
                      <pt-datepicker v-model="dateRangeForLineChart" :range="true" label="" />
                    </div>
                  </div>
                </div>
                <line-chart
                  v-if="lineChartLoaded"
                  :chart-data="lineChartCollection"
                  :options="lineChartOptions"
                  class="p-4 bg-white"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapGetters } from 'vuex';
import Layout from '@layouts/main';
import LineChart from '@components/custom/LineChart';
import BarChart from '@components/custom/BarChart';
import PieChart from '@components/custom/PieChart';
import apiRequest from '@src/utils/apiRequest';
import { PtDatepicker } from '@pathao/ui-components/esm/Datepicker';
import { PtSelect } from '@pathao/ui-components/esm/Select';
import { format } from 'date-fns';
import isBDPhoneNumber from '@src/utils/isBdNumber';
import {
  ORDER_RATIO,
  EARNING_HISTORY,
  PROCESSING_TIME,
  LIFETIME_STATS,
  POPULAR_ITEMS,
  PING_ORDER_SYNC,
} from '@src/config/apiEndpoints';

const options = {
  responsive: true,
  maintainAspectRatio: false,
};

export default {
  name: 'MyRestaurant',
  page: {
    title: 'My restaurant',
  },
  components: {
    Layout,
    LineChart,
    BarChart,
    PieChart,
    PtDatepicker,
    PtSelect,
  },
  // data: () => ({}),
  data() {
    const date = new Date();
    date.setDate(date.getDate() - 15);
    return {
      dateRangeForBarChart: {
        // earning history
        from: date,
        to: new Date(),
      },
      dateRangeForLineChart: {
        // avg processing time
        from: date,
        to: new Date(),
      },
      stats: '',
      fetchingInfo: false,
      restaurantInfo: '',
      popularItems: '',
      selecteSegment: { segment: 'day', name: 'Daily' },
      segmentOptions: [
        { segment: 'day', name: 'Daily' },
        { segment: 'week', name: 'Weekly' },
        { segment: 'month', name: 'Monthly' },
        { segment: 'year', name: 'Yearly' },
      ],
      lineChartLoaded: false,
      barChartLoaded: false,
      pieChartLoaded: false,
      lineChartCollection: {},
      barChartCollection: {},
      pieChartCollection: {},
      lineChartOptions: {
        ...options,
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function(value, index, values) {
                  return value + ' min';
                },
              },
            },
          ],
        },
      },
      barChartOptions: {
        ...options,
        isBDPhoneNumber,
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function(value, index, values) {
                  return value + (isBDPhoneNumber() ? ' TK' : ' NPR');
                },
              },
            },
          ],
        },
      },
      pieChartOptions: {
        ...options,
      },
      pullingOrder: false,
    };
  },
  computed: mapGetters({
    userName: 'auth/userName',
  }),
  watch: {
    dateRangeForBarChart: function(newVal) {
      if (newVal.from && newVal.to) {
        this.getBarChartData();
      }
    },
    dateRangeForLineChart: function(newVal) {
      if (newVal.from && newVal.to) {
        this.getLineChartData();
      }
    },
  },
  created() {
    this.$sendEvent('RS_MyRestaurant');
  },
  mounted() {
    this.getStats();
    this.getPopularItems();
    this.getLineChartData();
    this.getBarChartData();
    this.getPieChartData();
  },
  methods: {
    isBDPhoneNumber,
    getStats() {
      let payload = {
        url: LIFETIME_STATS,
        method: 'GET',
      };
      this.fetchingInfo = true;
      apiRequest(payload).then(response => {
        this.fetchingInfo = false;
        this.stats = response.data.stats;
        this.restaurantInfo = response.data.restaurant_information;
      });
    },
    getPopularItems() {
      let payload = {
        url: POPULAR_ITEMS,
        method: 'GET',
      };

      apiRequest(payload).then(response => {
        this.popularItems = response.data.popular_items;
      });
    },
    getLineChartData() {
      this.lineChartLoaded = false;
      let payload = {
        url: PROCESSING_TIME,
        method: 'POST',
        data: {
          from_date: format(this.dateRangeForLineChart.from, 'YYYY-MM-DD'),
          restaurant_name: this.userName,
          segment: this.selecteSegment.segment,
          to_date: format(this.dateRangeForLineChart.to, 'YYYY-MM-DD'),
        },
      };
      apiRequest(payload).then(response => {
        this.lineChartCollection = {
          labels: response.data.processing_chart.labels,
          datasets: [
            {
              label: 'Average Processing Time',
              data: response.data.processing_chart.values,
              backgroundColor: ['#5bb85b'],
              borderColor: ['#5bb85b'],
              borderWidth: 2,
              fill: false,
            },
          ],
        };
        this.lineChartLoaded = true;
      });
    },
    getBarChartData() {
      let payload = {
        url: EARNING_HISTORY,
        method: 'POST',
        data: {
          from_date: format(this.dateRangeForBarChart.from, 'YYYY-MM-DD'),
          restaurant_name: this.userName,
          segment: this.selecteSegment.segment,
          to_date: format(this.dateRangeForBarChart.to, 'YYYY-MM-DD'),
        },
      };
      apiRequest(payload).then(response => {
        this.barChartCollection = {
          labels: response.data.earning_chart.labels,
          datasets: [
            {
              label: 'Earning History',
              data: response.data.earning_chart.values,
              backgroundColor: '#5bb85b',
            },
          ],
        };
        this.barChartLoaded = true;
      });
    },
    getPieChartData() {
      let payload = {
        url: ORDER_RATIO,
        method: 'GET',
      };
      apiRequest(payload).then(response => {
        this.pieChartCollection = {
          labels: ['Delivered orders', 'Cancelled orders'],
          datasets: [
            {
              backgroundColor: ['#28a745', '#6c757d'],
              borderColor: ['#28a745', '#6c757d'],
              data: [response.data.stats.delivered_order_count, response.data.stats.cancelled_order_count],
            },
          ],
        };
        this.pieChartLoaded = true;
      });
    },
    pullOrder() {
      let payload = {
        url: PING_ORDER_SYNC,
        method: 'GET',
      };
      this.pullingOrder = true;
      apiRequest(payload)
        .then(response => {
          this.$notification.success('Order sync request is send');
        })
        .catch(error => {
          console.log(error);
          this.$notification.error('Order sync request is failed');
        })
        .finally(() => {
          this.pullingOrder = false;
        });
    },
  },
};
</script>

<style>
.multiselect__tags {
  min-height: unset;
  padding: 5px 40px 0 8px;
}
</style>
